import {createAsyncThunk} from '@reduxjs/toolkit'
import {
  FetchPeriodByIdRequest,
  UpdatePeriodRequest,
  FetchPeriodsRequest,
  CreatePeriodRequest,
  DeletePeriodRequest,
  SuspendPeriodRequest,
  ActivatePeriodRequest,
  FetchAllPeriodsRequest
} from './types'
import {AxiosError} from 'axios'
import {ResponseError} from '../commonTypes'
import {Period} from '../../../models'
import axios from 'axios'
import {
  fetchPeriodsUrl,
  fetchPeriodByIdUrl,
  createPeriodUrl,
  updatePeriodUrl,
  deletePeriodUrl,
  suspendPeriodUrl,
  activatePeriodUrl,
  fetchAllPeriodsUrl
} from '../../api'

export const fetchPeriods = createAsyncThunk(
  'period/fetch',
  async (payload: FetchPeriodsRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${fetchPeriodsUrl}?sortField=${payload.sortField}&sortOrder=${
          payload.sortOrder
        }&pageNumber=${payload.pageNumber}&pageCount=${payload.pageCount}${
          payload.search && payload.search.trim() !== '' ? '&search=' + payload.search.trim() : ''
        }`
      )
      const {periods, totalPages, total} = res.data
      return {
        periods,
        totalPages,
        total,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchAllPeriods = createAsyncThunk(
  'period/fetchAll',
  async (payload: FetchAllPeriodsRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${fetchAllPeriodsUrl}`
      )
      const {periods} = res.data
      return {
        periods,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchPeriodById = createAsyncThunk(
  'period/fetchById',
  async (payload: FetchPeriodByIdRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(`${fetchPeriodByIdUrl}/${payload.id}`)
      const {period} = res.data
      return {
        period,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const createPeriod = createAsyncThunk(
  'period/create',
  async (payload: CreatePeriodRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(createPeriodUrl, payload)
      const {period} = res.data
      return {
        period,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const updatePeriod = createAsyncThunk(
  'period/update',
  async (payload: UpdatePeriodRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(updatePeriodUrl, payload)
      const {period} = res.data
      return {
        period,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const deletePeriod = createAsyncThunk(
  'period/delete',
  async (payload: DeletePeriodRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(deletePeriodUrl, payload)
      const {period} = res.data
      return {
        period,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const suspendPeriod = createAsyncThunk(
  'period/suspend',
  async (payload: SuspendPeriodRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(suspendPeriodUrl, payload)
      const {period} = res.data
      return {
        period,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const activatePeriod = createAsyncThunk(
  'period/activate',
  async (payload: ActivatePeriodRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(activatePeriodUrl, payload)
      const {period} = res.data
      return {
        period,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)
